import { useState } from "react";
import ScheduleControl from "../../../components/Schedule/ScheduleControl";
import ScheduleTable from "../../../components/Schedule/ScheduleTable";
import CreateLessonModal from "../../../components/Schedule/CreateLessonModal";
import { read, utils } from "xlsx";
import Modal from "../../../components/Modal/Modal";
import DefaultButton from "../../../components/default-button/DefaultButton";
import ArrowLeft from "../../../assets/icons/ArrowLeft";
import Tick from "../../../assets/icons/Tick";
import { simpleGetter } from "../../../actions/common";
import { userApi } from "../../../api/api";
import { useHookstate } from "@hookstate/core";
import { useTeacherCourses } from "../../../hooks/lesson";
import { showSnackbar } from "../../../misc/utils";

export default function SchedulePage() {
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const coursesDataTriggerFetch = state.coursesDataTriggerFetch || 0;
  const coursesData = useTeacherCourses(coursesDataTriggerFetch);
  const [year, setYear] = useState<string>("");
  const [semester, setSemester] = useState<"fall" | "spring" | "">("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [createLessonModalOpen, setCreateLessonModalOpen] = useState<boolean>(false);
  const [addCoursesTable, setAddCoursesTable] = useState<any[]>([]);
  const [addCoursesModalVisible, setAddCoursesModalVisible] = useState(false);
  const [addCoursesObject, setAddCourseObject] = useState<any>({});

  const [sortBy, setSortBy] = useState<any>(undefined);
  const [sortDir, setSortDir] = useState<"asc" | "desc">("asc");

  const handleCreateLesson = (lessonData: any) => {
    console.log("Creating lesson:", lessonData);
    // TODO: Implement lesson creation logic
  };

  const createCoursesFromTable = async () => {
    const addCoursesKeys = Object.keys(addCoursesObject)
    console.log(addCoursesKeys.length)
    let sum = 0;
    for (let i = 0; i < addCoursesKeys.length; i += 4) {
      const sliced = addCoursesKeys.slice(i, i + 4);
      const object: any = {};
      for (const k of sliced) {
        object[k] = addCoursesObject[k];
      }
      const response = await simpleGetter(userApi.uploadTeacherClasses, {
        add_courses: object
      })
      console.log(i, response.success)
    }
    localState.merge({
      coursesDataTriggerFetch: coursesDataTriggerFetch + 1
    })
    setAddCoursesModalVisible(false)
    showSnackbar('Успешно', 'success')
  }

  const onExcelUpload = async (e: any) => {
    const finalTable = [];
    const teachersWithCourses: Record<string, any> = {}
    const file = e.target?.files?.[0]
    const data = await file?.arrayBuffer();
    const workbook = read(data);
    for (let sheetName of workbook.SheetNames) {
      if (sheetName === "Лист1") {
        const rowObject: any[] = utils.sheet_to_json(workbook.Sheets[sheetName])
        let cachedEmail = '', cachedCourseName = '', cachedLessonName = ''
        for (const rowIndex in rowObject) {
          const row = rowObject[rowIndex]
          console.log(rowIndex)
          const email = row['Email KBTU']
          const courseName = `(${row['Шифр дисц.']}) ${row['Название дисциплины']}`
          const lessonName = `${row['День']} ${row['Время']}`
          if (row['День']) {
            cachedEmail = email
            cachedCourseName = courseName
            cachedLessonName = lessonName
            teachersWithCourses[email] = {
              ...(teachersWithCourses[email] || {}),
              courses: {
                ...(teachersWithCourses[email]?.courses || {}),
                [courseName]: {
                  ...(teachersWithCourses[email]?.courses?.[courseName] || []),
                  [lessonName]: {
                    students: []
                  }
                }
              }
            }
          } else if (row['__EMPTY_1']) {
            teachersWithCourses[cachedEmail] = {
              ...(teachersWithCourses[cachedEmail] || {}),
              courses: {
                ...(teachersWithCourses[cachedEmail]?.courses || {}),
                [cachedCourseName]: {
                  ...(teachersWithCourses[cachedEmail]?.courses?.[cachedCourseName] || []),
                  [cachedLessonName]: {
                    students: [...(teachersWithCourses[cachedEmail]?.courses?.[cachedCourseName]?.[cachedLessonName]?.students || []), row['__EMPTY_1']]
                  }
                }
              }
            }
          }
        }
        setAddCourseObject(teachersWithCourses);
        const foundEmailsResponse = await simpleGetter(userApi.findByEmails, { emails: Object.keys(teachersWithCourses) });
        const list = foundEmailsResponse.list || []
        for (const teacherEmail of Object.keys(teachersWithCourses)) {
          if (!list.find((item: any) => item.json_saved_data?.email === teacherEmail)) {
            continue
          }
          for (const teacherCourse of Object.keys(teachersWithCourses[teacherEmail].courses)) {
            for (const teacherClass of Object.keys(teachersWithCourses[teacherEmail].courses[teacherCourse])) {
              finalTable.push({
                email: teacherEmail,
                course: teacherCourse,
                classLabel: teacherClass,
                studentsCount: teachersWithCourses[teacherEmail].courses[teacherCourse][teacherClass].students.length
              })
            }
          }
        }
        setAddCoursesTable(finalTable)
        setAddCoursesModalVisible(true);
      }
    }
  }

  return (
    <>
      <div className="w-full bg-white h-full py-2 px-4 rounded-lg">
        <ScheduleControl
          year={year}
          semester={semester}
          searchQuery={searchQuery}
          onYearChange={setYear}
          onSemesterChange={setSemester}
          onSearchChange={setSearchQuery}
          onCreate={() => setCreateLessonModalOpen(true)}
          onUpload={onExcelUpload}
        />
        <ScheduleTable
          searchQuery={searchQuery}
          sortBy={sortBy}
          sortDir={sortDir}
          data={coursesData}
        // data={...}
        // onEdit={(row) => ...}
        // onDelete={(row) => ...}
        />
      </div>

      <CreateLessonModal
        visible={createLessonModalOpen}
        setVisible={setCreateLessonModalOpen}
        onSubmit={handleCreateLesson}
      />

      <Modal
        additionalClassName="w-[62%] h-[90%] rounded-xl p-8 flex flex-col"
        visible={addCoursesModalVisible}
        setVisible={setAddCoursesModalVisible}
      >
        <div className='flex flex-col h-full overflow-auto gap-8'>
          <div className="flex flex-col gap-4">
            <span className='text-2xl text-valley-black leading-[26.4px]'>
              Курсы для добавления
            </span>
            <span className="text-valley-black">
              Убедитесь, что данные были считаны правильно. Нажмите на "Сохранить" для завершения загрузки курсов
            </span>
          </div>
          <div className="flex flex-col flex-1 text-valley-black overflow-auto">
            <div className="flex flex-row border-t border-valley-black">
              <div className="flex flex-row border-l border-valley-black justify-center py-3 px-2 w-1/3">
                <span className="font-bold">Почта</span>
              </div>
              <div className="flex flex-row border-x border-valley-black justify-center py-3 px-2 w-1/3">
                <span className="font-bold">Курс</span>
              </div>
              <div className="flex flex-row border-r border-valley-black justify-center py-3 px-2 w-1/3">
                <span className="font-bold">Класс</span>
              </div>
              <div className="flex flex-row border-r border-valley-black justify-center py-3 px-2 w-1/3">
                <span className="font-bold">Количество учеников в классе</span>
              </div>
            </div>
            {addCoursesTable.map((tableItem, i) => (
              <div className={`flex flex-row border-t ${i === addCoursesTable.length - 1 ? 'border-b' : ''} border-valley-black`}>
                <div className="flex flex-row border-l border-valley-black py-3 px-2 w-1/3">
                  <span>{tableItem.email}</span>
                </div>
                <div className="flex flex-row border-x border-valley-black py-3 px-2 w-1/3">
                  <span>{tableItem.course}</span>
                </div>
                <div className="flex flex-row border-r border-valley-black py-3 px-2 w-1/3">
                  <span>{tableItem.classLabel}</span>
                </div>
                <div className="flex flex-row border-r border-valley-black py-3 px-2 w-1/3">
                  <span>{tableItem.studentsCount}</span>
                </div>
              </div>
            ))}
          </div>
          <div className='flex flex-row gap-3'>
            <DefaultButton
              Icon={ArrowLeft}
              buttonText='Вернуться'
              additionalStyle='flex-1 bg-valley-gray text-white py-3'
              onClick={() => setAddCoursesModalVisible(false)}
            />
            <DefaultButton
              Icon={Tick}
              buttonText='Сохранить'
              additionalStyle='flex-1 bg-valley-main text-white py-3'
              onClick={createCoursesFromTable}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}